import React from 'react'
import { useLanguage } from '../config/language/LanguageContext';
import icon from "./../assets/icon.png";
import icon4 from "./../assets/icon4.png";
import icon8 from "./../assets/icon8.png";

const Services = () => {
  const { locale } = useLanguage();

  return (
  <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">
            {locale.SERVICES.heading}
          </h2>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[0, 1, 2].map((index) => {
              const card = locale.SERVICES.cards[index];
              const icons = [icon, icon8, icon4];
              const bgColors = [
                "bg-yellow-100",
                "bg-pink-100",
                "bg-purple-100",
              ];

              return (
                <div
                  key={card.title}
                  className="bg-white rounded-xl border border-gray-200 p-6"
                >
                  <div
                    className={`rounded-lg inline-block p-3 ${bgColors[index]}`}
                  >
                    <img
                      src={icons[index]}
                      alt={card.title}
                      className="h-8 w-8"
                    />
                  </div>
                  <h3 className="text-lg font-semibold mt-4 text-gray-800">
                    {card.title}
                  </h3>
                  <p className="text-gray-500 mt-2 text-sm">
                    {card.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
  )
}

export default Services
